import React from 'react'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

interface FormErrorComponentProps {
  message: string
  title?: string
}

const ErrorComponent: React.FC<FormErrorComponentProps> = (props: FormErrorComponentProps) => {
  const { message, title } = props
  return (
    <Alert severity="error" sx={{ mb: 3 }}>
      <AlertTitle>{(title !== undefined) ? title : 'Request has failed'}</AlertTitle>
      {message}
    </Alert>
  )
}

export default ErrorComponent
